import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import TeacherVoicePlayer from "@/components/landing/TeacherVoicePlayer";

const AboutTeacher = () => {
  const { t, lang } = useLanguage();
  return (
    <section
      id="teacher"
      data-testid="teacher-section"
      className="bg-[#f0efea] py-24 sm:py-32"
    >
      <span id="professor-frances-nativo" className="block -mt-24 pt-24" aria-hidden="true" />
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5">
          <div className="relative aspect-[4/5] overflow-hidden border border-[#e5e3db] bg-white">
            <img
              src="https://images.unsplash.com/photo-1550340499-a6c60fc8287c?auto=format&fit=crop&w=900&q=80"
              alt="Café e rua parisiense — cenário típico das aulas de francês com foco em cultura"
              loading="lazy"
              decoding="async"
              className="h-full w-full object-cover"
            />
            <div className="absolute bottom-4 left-4 right-4 bg-white/85 backdrop-blur-md px-4 py-3 border border-[#e5e3db]">
              <p className="overline">Paris · France</p>
              <p className="font-display italic text-[#1e2a5a] mt-1">
                « Parlez français dès les premiers cours ! »
              </p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <h2 className="overline">{t.teacher.seoH2}</h2>
          <p
            data-testid="teacher-title"
            className="font-display mt-4 text-4xl sm:text-5xl tracking-tight text-[#1e2a5a]"
          >
            {t.teacher.title}
          </p>
          <div className="mt-6 space-y-5 max-w-xl">
            {t.teacher.body.map((p, i) => (
              <p key={i} className="text-base sm:text-lg leading-relaxed text-[#5c5c5c]">
                {p}
              </p>
            ))}
          </div>

          {/* Voice intro — social proof audio right where the teacher intro lives */}
          <div className="mt-8 max-w-xl">
            <TeacherVoicePlayer
              lang={lang}
              variant="light"
              eventContext="landing_teacher"
            />
          </div>
          <div
            data-testid="teacher-stats"
            className="mt-10 grid grid-cols-3 max-w-md gap-6 border-t border-[#e5e3db] pt-8"
          >
            {t.teacher.stats.map((s, i) => (
              <div key={i}>
                <div className="font-display text-3xl sm:text-4xl text-[#1e2a5a]">
                  {s.value}
                </div>
                <div className="mt-1 text-xs uppercase tracking-[0.18em] text-[#5c5c5c]">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutTeacher;
